/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Create a public API to a decorator for the n-th vipr dataset
 *
 * @class DecoratorAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class Events {
		constructor(options) {
			this.transaction = options.dashboardFeatures.getFeature('Transaction');
		}

		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'canvas api',
					features: {
						'Dashboard.Transaction': this.transaction
					},
					events: {
						propagationInfo: {
							namespace: 'canvas',
							callStack: {
								name: 'getCanvas'
							}
						},
						actions:{
							selectContent: {

								eventName: 'selections:select',
								getInfo: (args) => {
									return {
										value: args[0]
									};
								},
								getUndoActions: (args) => [{
									name: 'deselectContent',
									params:[args[0]]
								}]
							},
							deselectContent: {
								eventName: 'selections:deselect',
								getInfo: (args) => {
									return {
										value: args[0]
									};
								},
								getUndoActions: (args) => [{
									name: 'selectContent',
									params:[args[0]]
								}]
							},
							moveContent: {
								type: 'move',
								eventName: 'content',
								transactionParamIndex: 2,
								transactionAPI: this.transaction,
								autoCreateTransaction: true,
								getInfo(args, returnValue, onBeforeAction){
									return {
										containerId: args[0],
										contentIdList: args[1],
										previousContainerId: onBeforeAction.undoActions[0].params[0],
										supportsUndoRedo: true
									};
								},
								getUndoActions: (args) => {
									const contentIdList = args[1];
									const undoActions = [];

									let id;
									let content;

									if(contentIdList){
										for(let i = contentIdList.length-1; i>=0;i--){
											id = contentIdList[i];
											content = this.getContent(id);
											// get the current parent
											const nextSibling = content.getFeature('Models.internal').getLayoutModel().getNextSiblingId();
											const params = [content.getContainer().getId(), [id]];
											if(nextSibling){
												params.push(undefined);
												params.push({ [id] : nextSibling });
											}
											undoActions.push({
												name: 'moveContent',
												params:params
											});
										}
									}
									return undoActions;
								}
							},
							setPropertyValue : {
								eventName:'property',
								getEventName: (args) => {
									return 'property:' + args[0];
								},
								getInfo: (args) => {
									let property = this._propertiesMap && this._propertiesMap[args[0]];
									if(!property) {
										property = this._getProperty(args[0]);
									}
									const info = {
										name: args[0],
										value: args[1],
										supportsUndoRedo: !!(property && property.supportsUndoRedo)
									};
									if(args[2]) {
										info.options = JSON.parse(JSON.stringify(args[2]));
									}
									return info;
								},
								getUndoActions: (args) => [{ params:[args[0], this.getPropertyValue(args[0])] }]
							}
						}
					}
				};
			}
			return this.apiSpec;
		}
	}

	return Events;
});
